import fetchClient from '../utils/fetchClient';

// Получить список уведомлений
export const getNotifications = async (params = {}) => {
    const searchParams = new URLSearchParams();
    
    if (params.skip !== undefined) searchParams.append('skip', params.skip);
    if (params.limit !== undefined) searchParams.append('limit', params.limit);
    if (params.is_read !== undefined) searchParams.append('is_read', params.is_read);
    if (params.is_new !== undefined) searchParams.append('is_new', params.is_new);
    if (params.notification_type !== undefined) searchParams.append('notification_type', params.notification_type);
    
    const queryString = searchParams.toString();
    const url = `/notifications${queryString ? `?${queryString}` : ''}`;
    
    return fetchClient.get(url);
};

// Получить типы уведомлений
export const getNotificationTypes = async () => {
    return fetchClient.get('/notifications/types');
};

// Получить количество уведомлений по типам
export const getNotificationTypeCounts = async () => {
    return fetchClient.get('/notifications/types/counts');
};

// Получить количество непрочитанных уведомлений
export const getUnreadNotificationCount = async () => {
    return fetchClient.get('/notifications/unread-count');
};

// Получить конкретное уведомление
export const getNotification = async (notificationId) => {
    return fetchClient.get(`/notifications/${notificationId}`);
};

// Обновить уведомление
export const updateNotification = async (notificationId, updateData) => {
    return fetchClient.patch(`/notifications/${notificationId}`, updateData);
};

// Отметить уведомление как прочитанное
export const markNotificationAsRead = async (notificationId) => {
    return fetchClient.post(`/notifications/${notificationId}/mark-read`);
};

// Отметить все как прочитанные
export const markAllAsRead = async () => {
    return fetchClient.post('/notifications/mark-all-read');
};

// Отметить все как не новые
export const markAllAsOld = async () => {
    return fetchClient.post('/notifications/mark-all-old');
};

// Удалить уведомление (мягкое удаление)
export const deleteNotification = async (notificationId) => {
    return fetchClient.delete(`/notifications/${notificationId}`);
};

// Получить настройки уведомлений
export const getNotificationSettings = async () => {
    return fetchClient.get('/notifications/settings/me');
};

// Обновить настройки уведомлений
export const updateNotificationSettings = async (settings) => {
    return fetchClient.patch('/notifications/settings/me', settings);
}; 